<template>
  <!-- addProviderModal -->
  <div
    id="deleteProviderModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="deleteProviderModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="deleteProviderModalLabel"
            class="modal-title"
          >
            {{ $t('label.affiliate.detail.addProvider.deleteProvider') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div
            v-if="isModalProcessing"
            class="text-center"
          >
            <img
              src="@/assets/img/loader.gif"
              class="center-block"
            >
          </div>
          <div v-else>
            <div
              v-if="modalError"
              class="col "
            >
              <div
                class="alert alert-danger text-center border-0 shadow-sm rounded-0"
              >
                {{ $t('error.'+`${modalResponseErr}`) }}
              </div>
            </div>
            <div
              v-else
              class="alert alert-warning"
            >
              {{ $t('label.affiliate.detail.addProvider.confirmationDeleteProvider') }} {{ providerId }} ?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn rounded-pill btn-secondary font-custom"
            data-bs-dismiss="modal"
          >
            {{ $t('label.modal.CONFIRMATION_MODAL_NO_BUTTON') }}
          </button>
          <BaseButton
            type="button"
            class="btn btn-danger"
            @click-base-button-event-emitter="deleteProvider()"
          >
            {{ $t('button.delete') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BaseButton from '@/components/BaseButton'
import { Modal } from 'bootstrap';
export default {
  components: {
    BaseButton
  },
  props: {
    affiliateDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      providerId: '',
      isModalProcessing: false,
      modalError: false
    }
  },
  created () {
  },

  methods: {
    show (provider) {
      this.isModalProcessing = false
      this.modalError = false
      this.providerId = provider.providerId
      let deleteProviderModal = new Modal(document.getElementById('deleteProviderModal'))
      deleteProviderModal.show()
    },
    async deleteProvider () {
      this.isModalProcessing = true
      this.modalResponseErr = null

      await this.$store.dispatch('affiliates/deleteProvider', {
        contractId: this.affiliateDetail.contractId,
        distributorRef: this.affiliateDetail.distributorId,
        commercialProduct: this.affiliateDetail.productId,
        providerId: this.providerId,
        affiliateEditMode: true
      }).then(
        () => {
          this.isModalProcessing = false
          this.modalError = false
          document.getElementById('deleteProviderModal').click()
        },
        error => {
          this.isModalProcessing = false
          this.modalError = true
          this.modalResponseErr = error.data.errorCode
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.error {
  color: red;
}

.validation-error {
  border-color: red;
  background: #FDD;

  &:focus {
    outline-color: rgb(250, 28, 28);
  }
}
</style>
